module.exports = __webpack_public_path__ + "images/130_1024.jpg";